import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { DocumentTitleService } from 'src/app/Service/DocumentTitle/DocumentTitle.service';
import { DocumentGroupService } from 'src/app/Service/DocumentGroup/DocumentGroup.service';
import { Empty_General_Group_Interface, General_Group_Interface } from 'src/app/Interface/General_Group_Interface';

@Component({
  selector: 'app-DocumentTitleEdit',
  templateUrl: './DocumentTitleEdit.component.html',
  styleUrls: ['./DocumentTitleEdit.component.scss']
})
export class DocumentTitleEditComponent implements OnInit {


  Token:String=""
  EditRecord:number

  constructor(
    private DocumentTitle_Service:DocumentTitleService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private DocumentGroup_Service:DocumentGroupService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.EditDocumentTitle=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      GroupId:new FormControl("0",Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(this.Token,27).subscribe(
      data=>{
        this.ReadData_DocumentGroup()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

  DataList_DocumentGroup:Array<General_Interface>=[]
  ReadData_DocumentGroup(){
    this.DocumentGroup_Service.GetActiveList(this.Token).subscribe(
      data=>{
        this.DataList_DocumentGroup=data

        this.DocumentTitle_Service.GetSingle(this.Token,this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
            this.get_Form_GroupId().setValue(data.group_id)

          }
        )

      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

    //#region  Form Add

    EditDocumentTitle:FormGroup;

    get_Form_Id(){
      return this.EditDocumentTitle.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditDocumentTitle.get('Title') as FormControl;
    }

    get_Form_GroupId(){
      return this.EditDocumentTitle.get('GroupId') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditDocumentTitle(){
      if(this.get_Form_GroupId().value=="0")
      {
        this.Alertify_Service.ErrorMessage("Please select a document group")
      }
      else{

        var Record:General_Group_Interface =Empty_General_Group_Interface()
        Record.id=this.EditRecord
        Record.title=this.get_Form_Title().value
        Record.group_id=Number(this.get_Form_GroupId().value)
        this.InProccessing=true
        this.DocumentTitle_Service.EditDocumentTitle(Record,this.Token).subscribe(
          data=>{
            this.InProccessing=false
            if(data.id==-2){
              this.Alertify_Service.ErrorMessage("The entered title already exists in the list")
            }
            else{

              this.Alertify_Service.SuccessMessage("The information was registered successfully")
            }
          }
        )
      }
    }



}
